import Config from '../config/index'
import Common from './commonclass'

class Auth {
    static myInstance = null
    userdata = {}
    constructor(){

    }

    static getInstance(){
        if(Auth.myInstance==null){
            Auth.myInstance = new Auth();
        }
        return this.myInstance;
    }

    setUserSession(session){ 
        localStorage.setItem(Config.sessionkey,JSON.stringify(session))
    }

    getUserSession(){
        const data = localStorage.getItem(Config.sessionkey);
        return Common.inEmpatyObject(data)===true ? false : JSON.parse(data)
    }

    getUserToken(){
        let data = localStorage.getItem(Config.sessionkey);
        data = Common.inEmpatyObject(data)===true ? false : JSON.parse(data)
        return data?.token;
    }

    removeUserSession(){
        localStorage.removeItem("token");
        localStorage.removeItem("userInfo");
        localStorage.removeItem(Config.sessionkey)
    }

    adminKeyForLogin(){
        return '4F5E3EvW7T7uv2DB';
    }

}

export default Auth.getInstance();